import React, { Fragment } from 'react'
import { Intro, Carousel, Voiceover } from 'cvs-core'
import img1 from '../../assets/images/U1-T1-8a.svg'
import img2 from '../../assets/images/U1-T1-8b.svg'
import img3 from '../../assets/images/U1-T1-8c.svg'
import voAudio from '../../assets/vo/Learn-Effects-of-Vaping-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Continue to learn more about the effects of vaping or using e-cigarettes on the body and brain.',
}

const data = {
  slides: [
    {
      image: img1,
      imageText: 'Brain',
      text: {
        title: 'Brain',
        text:
          'E-cigarettes contain highly addictive nicotine, and it can be hard to quit once you start. Addiction is a brain disease that changes your brain, often in a permanent way. Because teen brains are still developing, especially the decision-making prefrontal cortex, they are especially susceptible. This can cause trouble with memory, concentration, and decision making.',
      },
    },
    {
      image: img2,
      imageText: 'Body',
      text: {
        title: 'Body',
        text:
          'E-cigarettes deliver toxins all over your body. While the term “vaping” might make you think of water vapor, the aerosol you inhale when vaping is actually full of chemicals, many of them toxic. This can cause damage to your lungs, mouth, and throat. Finally, the liquid used to vape is harmful and can be fatal if swallowed.',
      },
    },
    {
      image: img3,
      imageText: 'That’s Not All!',
      text: {
        title: 'That’s Not All!',
        text:
          'Vaping comes with other risks as well. There have been reports of battery-operated e-cigarettes exploding in a person’s purse, pocket, or face. Also, the plastic casings, batteries, and e-juice can all harm the environment.',
      },
    },
  ],
}

export default {
  title: 'Effects of Vaping',
  path: '/learn/effects-of-vaping',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Effects of Vaping"
        direction="Use the arrows to learn more."
        lead="Click on the arrows to learn more about the effects of vaping/using e-cigarettes on the body and brain."
      />
      <Carousel data={data} />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/EffectsOfVaping.js